'use client';
import type { TemplatePageResponseT } from 'shared/cms/pickTemplateResponse';
import type { NormalizedTemplateCategoryT } from 'shared/cms/templateCategories/normalizeTemplateCategory';
import { TextBlockRenderer } from 'src/cms/TextBlockRenderer';
import { TemplateCard } from 'src/components/templates/TemplateCard/TemplateCard';
import { TemplateSEOText } from 'src/components/templates/TemplateSEOText/TemplateSEOText';
import { CTA } from 'src/ui/blocks';
import { GridBox } from 'src/ui/GridBox';
import CategoryNavigation from 'src/ui/templates/CategoryNavigation';
import { H2 } from 'src/ui/typography';

interface Props {
  category: NormalizedTemplateCategoryT;
  categories: NormalizedTemplateCategoryT[];
  templates: TemplatePageResponseT[];
}

export const TemplateSubcategoryContent = ({
  category,
  categories,
  templates,
}: Props) => {
  return (
    <>
      <CategoryNavigation categories={categories}>
        <H2>{category?.title}</H2>
        <GridBox
          gridGap="30px"
          gridTemplateColumns="repeat(auto-fill, minmax(280px, 1fr))"
          mb="space8"
        >
          {templates?.map((template) => (
            <TemplateCard
              template={template}
              key={template.slug}
              previewUrl={`/templates/p/${template.slug}`}
            />
          ))}
        </GridBox>
        {category?.seoText && (
          <TemplateSEOText>
            <TextBlockRenderer document={category.seoText} />
          </TemplateSEOText>
        )}
      </CategoryNavigation>
      <CTA />
    </>
  );
};
